<template>
  <div>
    <div class="multi-lang"> 
      <u class="linguval">{{ $t("About Us") }}</u>
    </div>
    <div v-html="dataset"></div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";

export default {
  data() {
    return {
      dataset: "",
      localDisplayLangCode: localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en",
    };
  },
  methods: {
    fetchAboutUsContent() {
      // Debugging: Log current language state
      console.log("fetchAboutUsContent called with:", {
        localDisplayLangCode: this.localDisplayLangCode,
        localStorageLang: localStorage.getItem("setDisplayLanguageCode"),
        i18nLocale: this.$i18n.locale,
      });

      // Determine About Us URL based on language
      const isEnglish = ["en", "eng"].includes(this.localDisplayLangCode);
      const aboutUsUrl = isEnglish
        ? "https://d3k6mli483yb9r.cloudfront.net/static/mvshub/en-es/aboutus.html"
        : "https://d3k6mli483yb9r.cloudfront.net/static/mvshub/es-ar/aboutus.html";

      // Debugging: Log the URL being fetched
      console.log("Fetching About Us from:", aboutUsUrl);

      fetch(aboutUsUrl)
        .then((res) => res.text())
        .then((result) => {
          this.dataset = result;
        })
        .catch((error) => {
          console.error("Error fetching About Us content:", error);
        });
    },
  },
  watch: {
    "$i18n.locale"(newLocale) {
      console.log("i18n.locale changed in AboutUs:", newLocale);
      if (this.localDisplayLangCode !== newLocale) {
        this.localDisplayLangCode = newLocale;
        this.fetchAboutUsContent();
      }
    },
  },
  created() {
    // Sync with i18n locale initially
    this.localDisplayLangCode =
      localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";

    // Listen for language change events
    eventBus.$on("check-local-storage", (data) => {
      console.log("check-local-storage event received in AboutUs:", data);
      this.localDisplayLangCode = data || this.$i18n.locale || "en";
      this.fetchAboutUsContent();
    });
    eventBus.$on("changeLanguageView", () => {
      console.log("changeLanguageView event received in AboutUs");
      this.localDisplayLangCode =
        localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";
      this.fetchAboutUsContent();
    });
  },
  mounted() {
    // Reset scroll position
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);

    // Set document title
    document.title = "About Us - MVSHUB";

    // Initial About Us fetch
    this.fetchAboutUsContent();
  },
  beforeDestroy() {
    // Clean up event listeners
    eventBus.$off("check-local-storage");
    eventBus.$off("changeLanguageView");
  },
};
</script>

<style scoped lang="scss">
.multi-lang {
  text-align: center;
  color: #777;
  font-size: 24px !important;
  font-weight: bold;
  margin-top: 4rem;
}
</style>